import { render, staticRenderFns } from "./applyDesc.vue?vue&type=template&id=745704b0&scoped=true"
import script from "./applyDesc.vue?vue&type=script&lang=js"
export * from "./applyDesc.vue?vue&type=script&lang=js"
import style0 from "./applyDesc.vue?vue&type=style&index=0&id=745704b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745704b0",
  null
  
)

export default component.exports